import { h } from "hyperapp";
import listCSS from "../../../src/sections/unvisited-places/list.css";

export const iconWithTooltip = ({ text = "", icon = "" }) => {
  const icons = {
    [icon]: () => <div />,
    clock: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M7.79999 0.75C3.51874 0.75 0.0499878 4.21875 0.0499878 8.5C0.0499878 12.7812 3.51874 16.25 7.79999 16.25C12.0812 16.25 15.55 12.7812 15.55 8.5C15.55 4.21875 12.0812 0.75 7.79999 0.75ZM7.79999 14.75C4.34686 14.75 1.54999 11.9531 1.54999 8.5C1.54999 5.04688 4.34686 2.25 7.79999 2.25C11.2531 2.25 14.05 5.04688 14.05 8.5C14.05 11.9531 11.2531 14.75 7.79999 14.75ZM9.73124 11.4875L7.07811 9.55937C6.98124 9.4875 6.92499 9.375 6.92499 9.25625V4.125C6.92499 3.91875 7.09374 3.75 7.29999 3.75H8.29999C8.50624 3.75 8.67499 3.91875 8.67499 4.125V8.55313L10.7625 10.0719C10.9312 10.1937 10.9656 10.4281 10.8437 10.5969L10.2562 11.4062C10.1344 11.5719 9.89999 11.6094 9.73124 11.4875Z"
          fill="#09D260"
        />
      </svg>
    ),
    search: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M15.7812 14.3344L12.6656 11.2188C12.525 11.0781 12.3344 11 12.1344 11H11.625C12.4875 9.89688 13 8.50937 13 7C13 3.40937 10.0906 0.5 6.5 0.5C2.90937 0.5 0 3.40937 0 7C0 10.5906 2.90937 13.5 6.5 13.5C8.00937 13.5 9.39688 12.9875 10.5 12.125V12.6344C10.5 12.8344 10.5781 13.025 10.7188 13.1656L13.8344 16.2812C14.1281 16.575 14.6031 16.575 14.8938 16.2812L15.7781 15.3969C16.0719 15.1031 16.0719 14.6281 15.7812 14.3344ZM6.5 11C4.29063 11 2.5 9.2125 2.5 7C2.5 4.79063 4.2875 3 6.5 3C8.70938 3 10.5 4.7875 10.5 7C10.5 9.20938 8.7125 11 6.5 11Z"
          fill="#1A69AD"
        />
      </svg>
    ),
  };

  return (
    <div class={listCSS["main-tooltip2"]}>
      {icons[icon]()}

      <div class={listCSS["tooltip-wrapper2"]}>
        <p class={listCSS["tooltip-text"]}>
          {text.replace(/<br\W*?\/>+/g, "\n")}{" "}
        </p>
      </div>
    </div>
  );
};
